import { css } from "@compiled/react";
import { useIntl } from "react-intl";

export const ErrorMessage = () => {
    const intl = useIntl();
    return (
        <div
            css={css({
                display: "flex",
                justifyContent: "center",
                height: "600px",
                alignItems: "center"
            })}
        >
            <div
                role="alert"
                aria-label={intl.formatMessage({
                    id: "pricing-calculator.error",
                    defaultMessage: "Error"
                })}
                data-testid="global-nav-user-profile-container-spinner"
            >
                ERROR
            </div>
        </div>
    );
};
